import { useState } from 'react';
import { useLocation } from 'react-router';
import { Bot, LayoutDashboard, Menu, Vote, X } from 'lucide-react';
import { Logo } from './Logo';
import { NavLink } from './NavLink';
import { MessageCounter } from './MessageCounter';
import { MobileMenu } from './MobileMenu';
import { WalletButton } from '../WalletButton';
import { NavItem } from './types';

const NAV_ITEMS: NavItem[] = [
  { path: '/explore', label: 'Explore Bots', icon: Bot },
  { path: '/voting', label: 'Voting', icon: Vote },
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
];

interface NavbarProps {
  messageBalance: number;
}

export function Navbar({ messageBalance }: NavbarProps) {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="relative z-10 border-b border-white/[0.08] bg-[rgba(0,0,0,0.9)] backdrop-blur-xl">
      <div className="max-w-full px-[24px] py-[16px]">
        <div className="flex items-center justify-between h-[40px]">
          {/* Left Section: Logo + Nav Links */}
          <div className="flex items-center gap-[32px] h-[40px]">
            <Logo />
          </div>

          {/* Navigation Links - Hidden on mobile */}
          <div className="hidden md:flex items-center gap-[4px] flex-1 h-[36px] max-w-[350px]">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.path}
                path={item.path}
                label={item.label}
                icon={item.icon}
                isActive={location.pathname === item.path}
              />
            ))}
          </div>

          {/* Right Section: Messages + Wallet / Mobile Menu */}
          <div className="flex items-center gap-[16px] h-[38px]">
            <MessageCounter balance={messageBalance} />
            
            <div className="hidden md:block">
              <WalletButton />
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden flex items-center justify-center w-[40px] h-[40px] text-white"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          <MobileMenu
            isOpen={mobileMenuOpen}
            navItems={NAV_ITEMS}
            messageBalance={messageBalance}
            onClose={() => setMobileMenuOpen(false)}
          />
        </div>
      </div>
    </nav>
  );
}
